import { useQuery } from "helpers/utils";
import { useEffect, useState } from "react";
import MainLayouts from "../../layouts/MainLayouts";
import RegisterDomain from "./RegisterDomain";
import TransferDomain from "./TransferDomain";
// import HostingProductSelector from "./HostingProductSelector";
import HostingProductSelectorNew from "components/HostingProductSelectorNew";

// Component untuk banner promo Kemerdekaan
const KemerdekaanPromoBanner = () => {
  const kemerdekaanStartDate = new Date("2025-08-17T00:00:00+07:00");
  const kemerdekaanEndDate = new Date("2025-08-18T23:59:59+07:00");
  const currentDate = new Date();
  const isKemerdekaanPromoActive = currentDate >= kemerdekaanStartDate && currentDate <= kemerdekaanEndDate;

  if (!isKemerdekaanPromoActive) return null;

  return (
    <div className="row justify-content-center mb-4">
      <div className="col-12">
        <div className="text-center" style={{
          borderRadius: '10px',
          overflow: 'hidden',
          border: '1px solid #f5c6cb'
        }}>
          {/* Bagian atas - merah */}
          <div style={{
            backgroundColor: '#dc3545',
            padding: '15px 20px',
            color: 'white'
          }}>
            <h4 className="mb-0" style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
              SPESIAL KEMERDEKAAN! DOMAIN .ID CUMA 50RB
            </h4>
          </div>

          {/* Bagian bawah - putih */}
          <div style={{
            backgroundColor: 'white',
            padding: '15px 20px',
            color: '#333'
          }}>
            <p className="mb-0" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
              Diperpanjang! Akan Berakhir pada 18 Agustus 2025.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const DomainOrder = () => {
  const query = useQuery();
  const domainRegister = query.domainregister;
  const domainTransfer = query.domaintransfer;
  const [domainMethod, setDomainMethod] = useState("register");
  const [registrationType, setRegistrationType] = useState("single");

  const methodActiveProps = {
    domainMethod,
    setDomainMethod,
    registrationType,
    setRegistrationType,
  };

  useEffect(() => {
    if (domainRegister) {
      setDomainMethod("register");
    }
  }, [domainRegister]);

  useEffect(() => {
    if (domainTransfer) {
      setDomainMethod("transfer");
    }
  }, [domainTransfer]);


  return (
    <MainLayouts summary={false}>
      <KemerdekaanPromoBanner />
      <RegisterDomain {...methodActiveProps} />
      <TransferDomain {...methodActiveProps} />
      {/* <HostingProductSelector /> */}
      <HostingProductSelectorNew />
    </MainLayouts>
  );
};

export default DomainOrder;
